import { RangeValue } from "@evergis/ui";
import { ClusterSymbolDc } from "@evergis/api";

import { map } from "../../evergis/map";

const { levels } = map.tileScheme;

export const DEFAULT_SCALE_RANGE: RangeValue = [levels[levels.length - 1].zIndex, levels[0].zIndex];

export const CLUSTER_STROKE_OPACITY = 0.28;

export const DEFAULT_CLUSTER_SVG = `
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 56 56" width="56px" height="56px">
  <circle cx="28" cy="28" r="22" fill="#00AAFF" stroke="#00AAFF" stroke-opacity="0.28" stroke-width="12" id="symbol-bg" />
</svg>
`;

export const DEFAULT_CLUSTER_SYMBOL = {
  type: "cluster",
  singleObjectSymbol: null,
  selectionObjectsLimit: 1000,
  fillColor: "#9d94feff",
  strokeColor: "#9d94fe33",
  strokeWidth: 12,
  maxClusterSize: 96,
  minClusterSize: 20,
  maxObjectCount: 100000,
  gridSize: 120,
  disabled: false,
  labelSymbol: {
    type: "labelPointSymbol",
    fieldFormat: "{count:n0}",
    fontFamily: "Arial",
    fontStyle: "normal",
    fontWeight: "Bold",
    fontColor: "#ffffffff",
    fontSize: {
      type: "byAttribute",
      defaultValue: 14,
      title: null,
      values: [
        {
          title: null,
          condition: "(count >= 1) && (count <= 10)",
          value: 14,
        },
        {
          title: null,
          condition: "(count > 10) && (count <= 100)",
          value: 18,
        },
        {
          title: null,
          condition: "(count > 100) ",
          value: 20,
        },
      ],
    },
    horizontalAlignment: "center",
    verticalAlignment: "middle",
    haloColor: "#ffffffff",
    haloWidth: 0,
    offset: [0, 0],
    textBackground: null,
    disabled: false,
  },
} as ClusterSymbolDc;
